export default "__VITE_ASSET__917891fd__"